module.exports = __webpack_public_path__ + "img/oregon.945bc413.png";